import {Point} from './abstract-units';
import jsonLayoutStyleVariables from '../../pages/dashboard/layout/layout-style-variables.json';

/**
 * Space between two cells. Used in calculation of cell's size according to widget's size.
 * @type {number}
 */
const CELLS_GAP: number = jsonLayoutStyleVariables.cellsGapPx;

/**
 * Cell header's height. Used in calculation of cell's height according to widget's height.
 * @type {number}
 */
const CELL_HEADER_HEIGHT: number = jsonLayoutStyleVariables.cellHeaderHeightPx;

/**
 * The value to add to a widget's size in order to get it's cell's size.
 * @type {Point}
 */
export const WIDGET_TO_CELL_SIZE_DELTA: Point = [CELLS_GAP, CELLS_GAP + CELL_HEADER_HEIGHT];

/**
 * Minimal Cell's size (px).
 * @type {[number , number]}
 */
export const MIN_CELL_SIZE: Point = [100, 100];

/**
 * How long distance mouse have to be moved before the widget starts moving (px).
 * @type {number}
 */
export const WIDGET_DRAG_CHARGE_OFFSET = 10;

/**
 * Defines bottom and right layout's padding for moving widget (px).
 * @type {number}
 */
export const MOVING_WIDGET_MIN_VISIBLE_SIZE = 20;

/**
 * Defines pause before the widget docking preview will be displayed (ms).
 * @type {number}
 */
export const MOVING_WIDGET_PREVIEW_PAUSE = 300;
